// ** Kameralar
const initialKameralarState = {}

const Kameralar = (state = initialKameralarState, action) => {
  switch (action.type) {
    case "SET_KAMERALAR_TYPES_CONTENT":
      return { ...action.val }
    default:
      return state
  }
}

export default Kameralar
